import { createSlice } from '@reduxjs/toolkit';

export const selectedComponentSlice = createSlice({
	name: 'selectComponent',
	initialState: {
		value: {},
	},
	reducers: {
		selectComponent: (state, action) => {
			state.value = action.payload;
		},
		selectComponentProps: (state, action) => {
			state.value.props = action.payload;
		},
	},
});
// Action creators are generated for each case reducer function
export const { selectComponent, selectComponentProps } = selectedComponentSlice.actions;
export const selectedComponent = (state) => state?.selectComponent?.value;
export default selectedComponentSlice.reducer;
